import React from 'react';
import ReactDOM from 'react-dom';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';

import './index.css';
import registerServiceWorker from './registerServiceWorker';
import App from './pages/App/App';
import {
    lightBlue50,
    lightBlue100,
    lightBlue600,
    deepPurple500
} from 'material-ui/styles/colors';

const app = (
    <MuiThemeProvider muiTheme={getMuiTheme({
        fontFamily: 'iransans, roboto, tahoma, sans-serif',
        isRtl: true,
        palette: {
            primary1Color: lightBlue600,
            primary2Color: lightBlue100,
            primary3Color: lightBlue50,
            accent1Color: deepPurple500,
        //     accent2Color: grey100,
        //     accent3Color: grey500,
            // textColor: darkBlack,
            // alternateTextColor: white,
            // canvasColor: white,
            // borderColor: grey300,
            // disabledColor: fade(darkBlack, 0.3),
            // pickerHeaderColor: cyan500,
            // clockCircleColor: fade(darkBlack, 0.07),
            // shadowColor: fullBlack,
          },
    })}>
        <App />
    </MuiThemeProvider>
)

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js